import { sel } from "../../academy/selectors";
import { TutorialDefinition } from "../types";

/**
 * Academy lesson: organize cases. Started from the lesson page in a new tab;
 * never auto-started. Nothing is deleted: the last step points at Trash.
 */
const tour: TutorialDefinition = {
  id: "categories-favorites-and-trash",
  version: "1.0.0",
  releasedAt: "2026-10-29T00:00:00.000Z",
  category: "onboarding",
  title: "Organize cases",
  description: "Create a category, file a case into it, star it, and find Trash.",
  triggerRoute: /^\/cases/,
  startRoute: "/cases",
  lessonId: "categories-favorites-and-trash",
  autoStart: false,
  steps: [
    {
      target: sel("newCategoryButton"),
      waitFor: sel("newCategoryButton"),
      waitTimeoutMs: 10000,
      title: "Create a category",
      content: "Click the + next to Categories, type a name in the New Category dialog, and click Create.",
      disableBeacon: true,
      placement: "right",
      advanceOn: { selector: sel("newCategoryButton"), event: "click" },
      hint: "Click the + to continue",
      spotlightClicks: true,
    },
    {
      target: sel("caseCategoryTag"),
      waitFor: sel("caseCategoryTag"),
      waitTimeoutMs: 10000,
      title: "File the open case",
      content: "With a case open, click the tag icon and tick the categories it belongs to. One case can sit in several.",
      disableBeacon: true,
      placement: "bottom",
    },
    {
      target: sel("favoriteStar"),
      waitFor: sel("favoriteStar"),
      title: "Add to Favorites",
      content: "Click the star to pin the open case under Favorites.",
      disableBeacon: true,
      placement: "bottom",
    },
    {
      target: sel("favoritesCategory"),
      waitFor: sel("favoritesCategory"),
      title: "Favorites",
      content: "Starred cases gather here. Click a category or Favorites to filter the case list to it.",
      disableBeacon: true,
      placement: "right",
    },
    {
      target: sel("trashNav"),
      waitFor: sel("trashNav"),
      title: "Trash",
      content: "Deleted cases wait here. Open one and click Restore to bring it back. The banner at the top of Trash shows how long they are kept.",
      disableBeacon: true,
      placement: "right",
    },
  ],
};

export default tour;
